import { createClient } from '@liveblocks/client';
import type { WithLiveblocks } from '@liveblocks/zustand';
import { liveblocks } from '@liveblocks/zustand';
import { TDescendant } from '@udecode/plate';
import { liveblocksPublicKey } from 'config';
import { create } from 'zustand';

export type UserPresence = {
  member: { email: string; id: string; avatar: string; firstname: string; lastname: string };
};

export type ChatEntry = {
  member: { email: string; id: string; avatar: string; firstname: string; lastname: string };
  timeStamp: string;
  id: string;
  chatData: TDescendant[];
};
export type ChatState = {
  chat: ChatEntry[];
  //appends chat message
  updateChat: (value: ChatEntry) => void;
  //replaces entire chat content
  updateChatPage: (value: ChatEntry[]) => void;
};

const client = createClient({
  publicApiKey: liveblocksPublicKey,
}) as any;

//TODO:Liveblocks Immer
const useChatStore = create<WithLiveblocks<ChatState>>()(
  liveblocks(
    (set) => ({
      chat: [],
      updateChat: (value: ChatEntry) =>
        set((state) => ({
          chat: state.chat.concat(value),
        })),

      updateChatPage: (chatMessages: ChatEntry[]) =>
        set((state) => {
          state.chat = chatMessages;
          return state;
        }),
    }),
    {
      client,
      storageMapping: { chat: true },
    }
  )
) as any;

export default useChatStore;
